export var breakpointRawMinWidthValues = {
  mobileLg: 0,
  tabletSm: 576,
  tabletMd: 768,
  tabletLg: 992,
  desktopSm: 1200,
  desktopMd: 1400
};
export var breakpointMinWidthValues = {
  mobileLg: "".concat(breakpointRawMinWidthValues.mobileLg, "px"),
  tabletSm: "".concat(breakpointRawMinWidthValues.tabletSm, "px"),
  tabletMd: "".concat(breakpointRawMinWidthValues.tabletMd, "px"),
  tabletLg: "".concat(breakpointRawMinWidthValues.tabletLg, "px"),
  desktopSm: "".concat(breakpointRawMinWidthValues.desktopSm, "px"),
  desktopMd: "".concat(breakpointRawMinWidthValues.desktopMd, "px")
};
export var breakpointsSmallToLarge = ['mobileLg', 'tabletSm', 'tabletMd', 'tabletLg', 'desktopSm', 'desktopMd'];
//# sourceMappingURL=Grid.constants.js.map